const state = () => ({
  tagsList: [],
});

const getters = {};

const actions = {};

const mutations = {
  updateTags(state, val) {
    state.tagsList = val;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
